import { render, staticRenderFns } from "./nova-empresa.vue?vue&type=template&id=9d6df522"
import script from "./nova-empresa.vue?vue&type=script&lang=js"
export * from "./nova-empresa.vue?vue&type=script&lang=js"
import style0 from "./nova-empresa.vue?vue&type=style&index=0&id=9d6df522&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports